export interface DistribuicaoBolsas {
  categoriaProfissional: string
  numeroBolsasSolicitadas: number
  numeroBolsasAprovadas: number
}

export const distribuicaoBolsasReference = {
  categoriaProfissional: undefined,
  numeroBolsasSolicitadas: 0,
  numeroBolsasAprovadas: 0,
}
